import { NgModule } from '@angular/core';
import {DisplayFieldPipe} from './displayField.pipe';
import {BooleanPipe} from './boolean.pipe';
import {CustomDatePipe} from './date.pipe';
import {DatePipe} from '@angular/common';
import {LocalDatePipe} from './local-date.pipe';
import {FileSizePipe} from './file-size.pipe';
import {CutPipe} from './cut.pipe';
import {CleanHtmlPipe} from './clean-html.pipe';

@NgModule({
  declarations: [
    DisplayFieldPipe, BooleanPipe, CustomDatePipe, LocalDatePipe, FileSizePipe, CutPipe, CleanHtmlPipe
  ],
  exports: [
    DisplayFieldPipe, BooleanPipe, CustomDatePipe, LocalDatePipe, FileSizePipe, CutPipe, CleanHtmlPipe
  ], providers: [
      DatePipe
  ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/pipes/pipes.module.ts